<template>
  <div v-if="is_vehicle && ppsrFetchResults" class="boxed-category">

    <group-card title="PPSR Search Result - Motor Vehicle Details" icon="fact_check">

      <div class="md-layout" v-if="ppsrFetchResults.vehicle_details">
        <div class="md-layout-item md-size-50">
          <property-view right name="Body" width="100%">
            {{ ppsrFetchResults.vehicle_details.Body }}
          </property-view>
        </div>
        <div class="md-layout-item md-size-50">
          <property-view right name="Build Year" width="100%">
            {{ ppsrFetchResults.vehicle_details.BuildYr }}
          </property-view>
        </div>
        <div class="md-layout-item md-size-50">
          <property-view right name="Cylinders" width="100%">
            {{ ppsrFetchResults.vehicle_details.Cylinders }}
          </property-view>
        </div>
        <div class="md-layout-item md-size-50">
          <property-view right name="Door" width="100%">
            {{ ppsrFetchResults.vehicle_details.Doors }}
          </property-view>
        </div>
        <div class="md-layout-item md-size-50">
          <property-view right name="Drive" width="100%">
            {{ ppsrFetchResults.vehicle_details.Drive }}
          </property-view>
        </div>
        <div class="md-layout-item md-size-50">
          <property-view right name="Fuel" width="100%">
            {{ ppsrFetchResults.vehicle_details.Fuel }}
          </property-view>
        </div>
        <div class="md-layout-item md-size-50">
          <property-view right name="Litres" width="100%">
            {{ ppsrFetchResults.vehicle_details.Litres }}
          </property-view>
        </div>
        <div class="md-layout-item md-size-50">
          <property-view right name="MY" width="100%">
            {{ ppsrFetchResults.vehicle_details.MY }}
          </property-view>
        </div>
        <div class="md-layout-item md-size-50">
          <property-view right name="Make" width="100%">
            {{ ppsrFetchResults.vehicle_details.Make }}
          </property-view>
        </div>
        <div class="md-layout-item md-size-50">
          <property-view right name="Model" width="100%">
            {{ ppsrFetchResults.vehicle_details.Model }}
          </property-view>
        </div>

        <div class="md-layout-item md-size-50">
          <property-view right name="Seats" width="100%">
            {{ ppsrFetchResults.vehicle_details.Seats }}
          </property-view>
        </div>

        <div class="md-layout-item md-size-50">
          <property-view right name="Series" width="100%">
            {{ ppsrFetchResults.vehicle_details.Series }}
          </property-view>
        </div>

        <div class="md-layout-item md-size-50">
          <property-view right name="Transmission" width="100%">
            {{ ppsrFetchResults.vehicle_details.Transmission }}
          </property-view>
        </div>

        <div class="md-layout-item md-size-50">
          <property-view right name="Vin" width="100%">
            {{ ppsrFetchResults.vehicle_details.VIN }}
          </property-view>
        </div>

        <div class="md-layout-item md-size-50">
          <property-view right name="Variant" width="100%">
            {{ ppsrFetchResults.vehicle_details.Variant }}
          </property-view>
        </div>
      </div>

      <div class="md-layout">
        <div class="md-layout-item md-small-size-100 md-size-33">
          <traffic-light-card
            title="Secured Party Details - Organisation Info"
            :status="getTrafficLight(ppsrFetchResults.ppsr_search_details.Interests)">
            <traffic-light-item>
              {{ ppsrFetchResults.ppsr_search_details.Interests > 0 ? 'Yes' : 'No' }}
            </traffic-light-item>
          </traffic-light-card>
        </div>

        <div class="md-layout-item md-small-size-100 md-size-33">
          <traffic-light-card
            title="NEVDIS Written-off Vehicle Notification"
            :status="getTrafficLight(ppsrFetchResults.ppsr_search_details.WOV)">
            <traffic-light-item>
              {{ ppsrFetchResults.ppsr_search_details.WOV > 0 ? 'Yes' : 'No' }}
            </traffic-light-item>
          </traffic-light-card>
        </div>

        <div class="md-layout-item md-small-size-100 md-size-33">
          <traffic-light-card
            title="NEVDIS Stolen Vehicle Notification"
            :status="getTrafficLight(ppsrFetchResults.ppsr_search_details.Stolen)">
            <traffic-light-item>
              {{ ppsrFetchResults.ppsr_search_details.Stolen > 0 ? 'Yes' : 'No' }}
            </traffic-light-item>
          </traffic-light-card>
        </div>
      </div>


    </group-card>

  </div>
</template>

<script>
import GroupCard from '@/components/Cards/GroupCard';
import GroupCardRow from '@/components/Cards/GroupCardRow';
import PropertyView from '@/components/ApplicationSummary/PropertyView';
import TrafficLightCard from '@/components/Cards/TrafficLightCard';
import TrafficLightItem from '@/components/Cards/TrafficLightItem';
import {mapGetters} from "vuex";

export default {
  data() {
    return {
      is_vehicle: this.$store.getters.application.loan.asset.type == 'Vehicle',
    }
  },
  props: {
    ppsrFetchResults: {
      type: Object,
      default: null,
    },
  },
  components: {
    GroupCard,
    GroupCardRow,
    PropertyView,
    TrafficLightCard,
    TrafficLightItem,
  },
  methods: {
    getTrafficLight(param) {
      if (param == '') {
        return 'good';
      }
      return 'bad';
    }
  }
}
</script>

<style scoped>

</style>
